import ngFileUpload from 'ng-file-upload';
import template from './imageLibraryDropzone.html';

export const ImageLibraryDropzoneModule = angular
    .module('app.components.imageLibrary.imageLibraryDropzone', [
        ngFileUpload
    ]).directive('imageLibraryDropzone', () => {
        return {
            restrict: 'E',
            template,
            scope: {
                files: '=',
                invalidFiles: '='
            },
            link: (scope) => {
                let dz = angular.element('.image-library-dropzone');
                let body = angular.element('body');

                body.on('dragover', (e) => {
                    let dataTypes = e.originalEvent.dataTransfer.types;
                    let isFile = Array.isArray(dataTypes) ?
                        dataTypes.indexOf('Files') !== -1 : dataTypes.contains('Files');
                    if (isFile) {
                        dz.addClass('dragover--isfile');
                    }
                });

                body.on('dragleave', (e) => {
                    let target = angular.element(e.target);

                    if (target.is(dz)) {
                        dz.removeClass('dragover--isfile');
                    }
                });

                body.on('dragend', () => {
                    dz.removeClass('dragover--isfile');
                });

                body.on('drop', () => {
                    dz.removeClass('dragover--isfile');
                });

                scope.$on('$destroy', () => {
                    angular.element('body').off('dragover');
                    angular.element('body').off('drop');
                    angular.element('body').off('dragend');
                    angular.element('body').off('dragleave');
                });
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/imageLibrary/imageLibraryDropzone.directive.js